module.exports = __webpack_public_path__ + "img/icon_map_0_off_100.6843238e.png";